import { createSlice } from '@reduxjs/toolkit';
import { getReport, getReportArticles } from './asyncReport';

const initialState = {
  isLoading: false,
  isError: null,
  reload: 0,
  data: [],
  articles: [],
};

export const REPORT_SLICE = createSlice({
  name: 'report',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getReport.pending, (state) => {
        state.isLoading = true;
        state.isError = null;
      })
      .addCase(getReport.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload;
      })
      .addCase(getReport.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      });
    builder
      .addCase(getReportArticles.pending, (state) => {
        state.isLoading = true;
        state.isError = null;
      })
      .addCase(getReportArticles.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.articles = payload || [];
      })
      .addCase(getReportArticles.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});

// Action creators are generated for each case reducer function
export const {} = REPORT_SLICE.actions;

export default REPORT_SLICE.reducer;
